import React, { useEffect, useState } from "react";
import {
  Nav,
  Container,
  Breadcrumb,
  Button,
  Modal,
  Spinner,
  Row,
} from "react-bootstrap";
import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarDashboard from "../../../components/SidebarDashboard";
import Indkator from "./Indkator";
import JobDescription from "./JobDescription";
import GeneralData from "./GeneralData";
import JobProfile from "./JobProfile";
import PoliticsAndProcedures from "./PoliticsAndProcedures";
import CompetenciesLevel from "./CompetenciesLevel";
import FactorsAndCriteria from "./FactorsAndCriteria";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  editDescriptor,
  getDescriptor,
} from "../../../redux/descriptorsProfiles/GeneralInfo/actions";
import { getEmployee } from "../../../redux/employees/actions";
import { getPDFDocument } from "../../../redux/descriptorsProfiles/GeneralInfo/actions";
import DocumentoDescriptorPDFComponent from "../../../components/descriptorsProfiles/DocumentoDescriptorPDF";

const MenuDesc = (props) => {
  // State
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const dispatch = useDispatch();
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(1);
  const [loadingPrint, setLoadingPrint] = useState(false);

  const { saveLoading, descriptorAcepta } = useSelector(
    (store) => store.generalInfo
  );

  const fechaActual = new Date();
  // Variables
  const userRoles = useSelector((store) => store.auth.userRoles);
  const id = useSelector((store) => store.auth.id);
  const userType = useSelector((store) => store.auth.userType);
  const username = useSelector((store) => store.auth.username);
  // const userId = useSelector((store) => store.auth.userId);
  const employee = useSelector((store) => store.employees.employee);
  const loading = useSelector((store) => store.employees.loading);
  const { location } = props;
  let { path, url } = useRouteMatch();
  const history = useHistory();

  // Method
  const onShowSidebar = () => setShow(show ? false : true);

  useEffect(() => {
    if (id && userType) {
      dispatch(getEmployee(id, parseInt(userType)));
      _getDescriptor();
    }
  }, [id, userType]);

  useEffect(() => {
    if (
      employee &&
      employee.id &&
      descriptorAcepta &&
      descriptorAcepta.acepto_descriptor
    ) {
      dispatch(
        getPDFDocument(parseInt(props.match.params.id), { md: employee.id })
      );
    }
  }, [employee, descriptorAcepta]);

  const _getDescriptor = (offs = offset, lim = limit) =>
    dispatch(
      getDescriptor({
        offset: offs,
        limit: lim,
        tipo_busqueda: "colaborador",
        filter: parseInt(id),
      })
    );

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          {/* {userRoles.length > 0 &&
          !(
            userRoles.includes("jefe") ||
            userRoles.includes("administrador") ||
            userRoles.includes("alta_direccion") ||
            userRoles.includes("Responsable_Descriptores_Perfiles")
          ) */}
          {props.match.params.miDescriptor ? null : (
            <>
            {console.log("props",props)}
              <div className="mb-4 px-2">
                <div className="d-flex flex-wrap justify-content-start align-items-center">
                  <Button
                    onClick={() => history.goBack()}
                    variant="link"
                    className="font-weight-bold mr-4 text-dark"
                  >
                    <i className="material-icons">arrow_back</i>
                  </Button>
                  <Breadcrumb className="pb-0">
                    <Breadcrumb.Item
                      title
                      onClick={() =>
                        history.push(`/descriptores-perfiles/menu-usuario`)
                      }
                      className="text-uppercase"
                    >
                      MANUAL DE PUESTOS Y FUNCIONES
                    </Breadcrumb.Item>
                    <Breadcrumb.Item
                      title
                      onClick={() =>
                        history.push(
                          `/descriptores-perfiles/seleccion-del-descriptor/${props.match.params.idFunc}/${props.match.params.nombreFuncion}`
                        )
                      }
                      className="text-uppercase"
                    >
                      {props.match.params.nombreFuncion.replaceAll("-", "/")}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className="text-uppercase" active title>
                      {props.match.params.nombre.replace("-", "/")}
                    </Breadcrumb.Item>
                  </Breadcrumb>
                </div>
              </div>
              <hr />
            </>
          )}
          <Nav variant="pills" activeKey={location.pathname}>
            <Nav.Item>
              {/* <Link className="nav-link active" to={`${url}`}>
                Datos generales
              </Link> */}
              <Nav.Link
                eventKey={`${url}`}
                onClick={() => history.push(`${url}`)}
              >
                Datos generales
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              {/* <Link className="nav-link" to={`${url}/descriptor-del-puesto`}>
                Descriptor del puesto
              </Link> */}
              <Nav.Link
                eventKey={`${url}/descriptor-del-puesto`}
                onClick={() => history.push(`${url}/descriptor-del-puesto`)}
              >
                Descriptor del puesto
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              {/* <Link className="nav-link" to={`${url}/indicadores`}>
                Indicadores
              </Link> */}
              <Nav.Link
                eventKey={`${url}/indicadores`}
                onClick={() => history.push(`${url}/indicadores`)}
              >
                Indicadores
              </Nav.Link>
            </Nav.Item>
            {/* <Nav.Item>
              <Link className="nav-link" to={`${url}/asignar-competencias`}>
                Competencias
              </Link>
              <Nav.Link
                eventKey={`${url}/asignar-competencias`}
                onClick={() => history.push(`${url}/asignar-competencias`)}
              >
                Competencias
              </Nav.Link>
            </Nav.Item> */}
            <Nav.Item>
              {/* <Link className="nav-link" to={`${url}/asignar-competencias`}>
                Competencias
              </Link> */}
              <Nav.Link
                eventKey={`${url}/competencias`}
                onClick={() => history.push(`${url}/competencias`)}
              >
                Competencias
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              {/* <Link
                className="nav-link"
                to={`${url}/politicas-y-procedimientos`}
              >
                Politícas y procedimientos
              </Link> */}
              <Nav.Link
                eventKey={`${url}/politicas-y-procedimientos`}
                onClick={() =>
                  history.push(`${url}/politicas-y-procedimientos`)
                }
              >
                Politícas y procedimientos
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              {/* <Link className="nav-link" to={`${url}/perfil-del-puesto`}>
                Perfil del puesto
              </Link> */}
              <Nav.Link
                eventKey={`${url}/perfil-del-puesto`}
                onClick={() => history.push(`${url}/perfil-del-puesto`)}
              >
                Perfil del puesto
              </Nav.Link>
            </Nav.Item>
           
            <Nav.Item>              
              <Nav.Link
                eventKey={`${url}/factores-y-criterios`}
                onClick={() => history.push(`${url}/factores-y-criterios`)}
              >
                Factores y Criterios
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <Container>
            <div className="mb-4 px-2 py-2 d-grid gap-2 d-md-flex justify-content-md-end flex-wrap align-items-center">
              {loading ? (
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center"
                />
              ) : (
                <>
                  {employee &&
                  employee.descriptor_List &&
                  parseInt(props.match.params.id) ===
                    employee.descriptor_List.id ? (
                    <Row className="d-md-flex justify-content-md-end flex-wrap align-items-center">
                      <Button
                        className="rounded-pill colorBtn"
                        variant="primary"
                        onClick={handleShow}
                        disabled={
                          descriptorAcepta && descriptorAcepta.acepto_descriptor
                        }
                      >
                        Aceptar descriptor
                      </Button>
                      {descriptorAcepta &&
                      descriptorAcepta.acepto_descriptor ? (
                        <DocumentoDescriptorPDFComponent
                          id={props.match.params.id}
                          id_colab={employee.id}
                          setLoadingPrint={setLoadingPrint}
                          nombre={props.match.params.nombre}
                        />
                      ) : null}
                    </Row>
                  ) : null}
                </>
              )}
            </div>
          </Container>
          <Switch>
            <Route path={`${path}`} exact component={GeneralData} />
            <Route
              path={`${path}/descriptor-del-puesto`}
              exact
              component={JobDescription}
            />
            <Route path={`${path}/indicadores`} exact component={Indkator} />
            <Route
              path={`${path}/perfil-del-puesto`}
              exact
              component={JobProfile}
            />
            <Route
              path={`${path}/politicas-y-procedimientos`}
              exact
              component={PoliticsAndProcedures}
            />
            {/* <Route
              path={`${path}/asignar-competencias`}
              exact
              component={AssignCompetencies}
            /> */}
            <Route
              path={`${path}/competencias`}
              exact
              component={CompetenciesLevel}
            />
            <Route
              path={`${path}/factores-y-criterios`}
              exact
              component={FactorsAndCriteria}
            />
          </Switch>
        </Container>

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Aceptar descriptor</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Después de haber leído, entendido y revisado Mi descriptor de
              puesto. Me comprometo a seguir y cumplir con mis responsabilidades
              y así realizar mi trabajo con el mayor cuidado, eficiencia y
              esmero en las labores a mí encomendadas, acepto el mismo a los{" "}
              {moment(fechaActual).format("DD")} del{" "}
              {moment(fechaActual).format("MM")} del{" "}
              {moment(fechaActual).format("YYYY")}.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={handleClose}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              variant="primary"
              disabled={descriptorAcepta && descriptorAcepta.acepto_descriptor}
              onClick={(e) => {
                debugger;
                dispatch(
                  editDescriptor(
                    // {
                    //   descriptor_id: parseInt(props.match.params.id),
                    //   colaborar_id: id,
                    // },
                    // parseInt(props.match.params.id)

                    { acepto_descriptor: true },
                    descriptorAcepta.id
                    // setShowModal
                  )
                );
                handleClose(e);
              }}
            >
              {saveLoading && (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              Aceptar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default MenuDesc;
